import React, { useState } from "react";
import PageDetails from "../components/details/pageDetails";
import Footer from "../components/footer/footer";
import Headers from "../components/header";


function DetailPage() {
  const [loading, setLoading] = useState(false);

  const handleSetLoading = () => {
    setLoading(false);
  }

  const urlParams = new URLSearchParams(window.location.search);
  const query = urlParams.get("query");

  return (
    <>
      <Headers loading={loading} />
      <PageDetails setLoading={handleSetLoading} loading={loading} permalink={query} />
      {/* <Footer /> */}
    </>
  );
}

export default DetailPage;
